import React from "react";
import ContentLoader from "react-content-loader";

const NoticePlaceholder = () => {
  return (
    <div>
      <ContentLoader viewBox="0 0 500 20" className="mb-2">
        <rect x="0" y="0" rx="0" ry="0" width="500" height="100" />
      </ContentLoader>
      <ContentLoader viewBox="0 0 500 15" className="mb-2">
        <rect x="0" y="0" rx="0" ry="0" width="100" height="100" />
      </ContentLoader>
      <ContentLoader viewBox="0 0 500 200">
        <rect x="0" y="0" rx="0" ry="0" width="500" height="200" />
      </ContentLoader>
    </div>
  );
};

export default NoticePlaceholder;
